import React, { useEffect, useMemo, useRef, useState } from 'react';

import { IconButton, Stack, Typography, Box, Modal, Chip, Tabs, Tab, List, ListItem, ListItemButton, ListItemText, Collapse, Divider } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid2';


import '../../assets/styles/Header.scss';
import { CallbackRegistryItem, QueuedEventListener, WebSocketMessage, selectCachingForOffline, selectCallbackRegistry, selectConnected, selectCurrentEventListeners, selectEventContexts, selectEventtypes, selectMessagesInOrder, selectOffline, selectPendingEventListeners, selectQueuedEventListeners, selectVersion } from '../../services/redux/shuteSlice'; 
// import ErrorContext, { ErrorContextType } from '../../contexts/ErrorContext';
import { selectMostSevere , setConsoleOpen, severityColors, severityIcons } from '../../services/redux/consoleSlice';
import OrbotnikIcon from '../common/Icons/Icons';
import { useAppDispatch, useAppSelector } from '../../services/redux/hooks';
import SW from '../../services/pwa/SW';
import { ColoredChip, ColoredTag } from '../common/Tag/ColoredTag';
import { JsonViewer } from '@textea/json-viewer';
// import { Textfit } from 'react-textfit';
import ElapsedTime from '../administration/preferencecontrols/ElapsedTime';
import { OrbotnikColourVariant } from '../../types/types';
import { useSputnikContext, withWrappedSputnik, WrappedSputnikProps } from '../common/hoc/WrappedSputnik';
import LoadingComponent from '../common/waiting/LoadingBox';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import FlexContainer from '../common/flexcontainer/FlexContainer';
import FlexChild from '../common/flexcontainer/FlexChild';


interface NavBarProps {
  environmentWarning?: string;
  tldr?: string;
}
const Item = styled('div')({
  textAlign: 'left',
});

function BaseDeveloperHeader(props: WrappedSputnikProps<any, any> & NavBarProps) {
  // Destructure and use the props and context values as needed
  const { updateControlPrefs, controlPrefs, environmentWarning, tldr } = props;

    const theme = useTheme();
    const dispatch = useAppDispatch();
    const { showAlert, setEventTypeListener,updateMountState,fnConsoleError } = useSputnikContext();
    useEffect(() => {
      updateMountState('mount');
      return () => {
        updateMountState('unmount');
      };
    }, []);
    const isOffline = useAppSelector(selectOffline); 
    const isConnected = useAppSelector(selectConnected); 
        
    const cachingForOffline = useAppSelector(selectCachingForOffline); 
    const version = useAppSelector(selectVersion); 
    const mostSevere = useAppSelector(selectMostSevere);
    
    const hasLogs = mostSevere !== null;
  
    const [flash, setFlash] = useState(false);

 
    const [showShuteHx, setShowShuteHx] = useState(false);

    const handlePingEvent = (message: WebSocketMessage) => {
      // console.log('herer?')
      setFlash(prevState => !prevState); // Toggle flash
        setTimeout(() => {
          setFlash(prevState => !prevState); // Toggle flash back
        }, 10000);
    }

    // useComponentLogger('DeveloperHeader');
    // const notifyEventTypes = ["shute.ping"]

    const notifyEventTypes = useMemo(() => ["shute.ping"], []);
    // useEventCallbacks(notifyEventTypes, handlePingEvent);
    useEffect(() => {
      // setup a handler to catch the events as they come in
      setEventTypeListener(notifyEventTypes, handlePingEvent,'');
    }, []);
    const divRef = useRef<HTMLDivElement>(null);
  
    const handleShowConsole = () => {
      const rect = divRef.current!.getBoundingClientRect();
      const position = {
        x: rect.right,
        y: rect.bottom,
      };
  
      dispatch(setConsoleOpen({consoleOpen:true, position}));
    };
    let variant:OrbotnikColourVariant, label, tooltip;
    if (isOffline) {
      variant = "red";
      label = "OFFLINE";
      tooltip = "Sputnik server is unavailable";
    } else if (!isConnected) {
      variant = "orange";
      label = "NOT CONNECTED";
      tooltip = "Sputnik shute is not connected";
    } else {
      variant = "green";
      label = version || "0.0.0";
      tooltip = "Sputnik shute is connected";
    }
    
    const iconClass = mostSevere ? severityIcons[mostSevere] : "default-icon";
    const iconColor = mostSevere ? severityColors[mostSevere] : "inherit";
    

    // const scrollToBottom = () => {
      
    //   console.log(contentRef.current?.scrollTop)
    //   bottomEl?.current?.scrollIntoView({ behavior: 'smooth' });
    //   console.log(bottomEl)
    //   console.log(contentRef.current?.scrollTop)
    // };    
    // useEffect(() => {
    //   const element = contentRef.current;
    //   if (element) {
    //       // Check if user is already at the bottom
    //       const isScrolledToBottom = element.scrollHeight - element.clientHeight <= element.scrollTop ; 
    //       console.log(isScrolledToBottom, element.scrollHeight , element.clientHeight,element.scrollTop)
    //       if (isScrolledToBottom) {
    //           scrollToBottom();
    //         }
    //   }
    // }, [shuteMessageHx]);    
    // useEffect(() => {
    //   console.log(contentRef.current?.scrollTop)
    // }, [contentRef.current?.scrollTop]);      
    const handleOpen = () => {
      // console.log(shuteMessageHx)
      setShowShuteHx(true);
    };
    // const hiddenRowRef = useRef<HTMLDivElement>(null);
    const handleClose = () => {
      setShowShuteHx(false);
    };




    if (!controlPrefs?.expansions) {
      return (
        <LoadingComponent toolTip="Waiting for user preferences" />
      )
    }  
    // return <></> 
    return (
      <div id="div_DeveloperHeader">
        <Grid container direction="row" className="nav tiny" style={{ filter: "brightness(85%)" }}
          sx={{ backgroundColor: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText }} // Access primary dark color
        >
          <Grid xs={6} className="nav tiny">
            <Item>
              <div className="nav tiny">
                <Stack direction="row" alignItems="center" gap={0}>
                  <IconButton>
                    <OrbotnikIcon iconName='Info' color="contrast" />
                    {/* <Info sx={{ color: theme.palette.primary.contrastText }}/> */}
                  </IconButton>
                  {/* <Textfit mode="single" min={10} max={24} forceSingleModeWidth={false}> */}
                    <strong>{environmentWarning}</strong>
                  {/* </Textfit>  */}
                  {/* <Typography variant="body1"><strong>{environmentWarning}</strong></Typography> */}
                </Stack>
              </div>
            </Item>
          </Grid>
  
          <Grid xs={3}>
            <Item>
              <Box ref={divRef} display="flex" justifyContent="flex-end" alignItems="center" flexDirection="row">
                {hasLogs &&                 
                  <IconButton onClick={handleShowConsole}>
                    {/* <OrbotnikIcon iconName={severityIcons[severity]} color={severityColors[severity]} /> */}
                    <OrbotnikIcon iconName={iconClass} color={iconColor} />
                  </IconButton>} 
              </Box>   
            </Item>
          </Grid>        
          <Grid xs={3}>
            <Item>
              <Box display="flex" justifyContent="flex-end" alignItems="center" flexDirection="row" mx={0.5} gap={0.5}>
                {cachingForOffline 
                  && <ColoredChip variant="volcano" label="cache data" tooltip="caching data for offline usage" />       
                }
                <SW />    
                <Box className={flash ? '' : ''} style={{
                    width: "2.5em",
                    height: "2.5em",
                    borderRadius: "50%",
                    backgroundColor: "#98fb98",
                    opacity: "0"
                  }} />
                {/* Sputnik api state worker status */}
                <ColoredChip 
                    className={flash ? 'glow' : ''} 
                    variant={variant} 
                    label={label} 
                    tooltip={tooltip} 
                    onClick={handleOpen}
                />

              </Box>         
            </Item>
          </Grid>
        </Grid>
        <Modal
            open={showShuteHx}
            onClose={handleClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
          <>
            <EventsModal 
              controlPrefs={controlPrefs} 
              updateControlPrefs={updateControlPrefs} />
          </>
        </Modal>

      </div>
    )
  }


const EnhancedComponent = withWrappedSputnik<any,any>(BaseDeveloperHeader); 
const DeveloperHeader: React.FC<NavBarProps> = (props) => {
  return <EnhancedComponent {...props} userSavedComponentPrefsKey="developerheader.main" />
}
// const BugattiAdmin: React.FC<WrappedSputnikProps<any,any>> = (props) => {
//     return <EnhancedComponent {...props} userSavedComponentPrefsKey="developerheader.main" />;
// }

export default DeveloperHeader




interface EventsModalProps extends Pick<WrappedSputnikProps<any,any>,'controlPrefs' | 'updateControlPrefs'> {
}

const EventsModal: React.FC<EventsModalProps> = ({controlPrefs,updateControlPrefs}) => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const bottomEl = useRef<HTMLDivElement | null>(null);
  const [tabSelected, setTabSelected] = useState(0); 

  const uniqueEventTypes = useAppSelector(selectEventtypes); 
  const [expandFilters, setExpandFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(() => {
    if (controlPrefs?.expansions) {
      return Object.keys(controlPrefs?.expansions).filter(key => controlPrefs?.expansions[key.replace('~','.')]);
    } else {
      return [];
    }
  });     
  const shuteMessageHx = useAppSelector((state) => selectMessagesInOrder(state, { reverseOrder: false }));
  const currentEventListeners = useAppSelector(selectCurrentEventListeners);
  const pendingEventListeners = useAppSelector(selectPendingEventListeners);
  const queuedEventListeners = useAppSelector(selectQueuedEventListeners);
  const listeners = useAppSelector(selectEventContexts);
  const callbackRegistry = useAppSelector(selectCallbackRegistry);

  const toggleFilter = (type:string) => {
    const replType = type.replace('.','~')
    if (selectedFilters.includes(type)) {
        setSelectedFilters(prev => prev.filter(t => t !== type));
        if (updateControlPrefs) updateControlPrefs({'expansions':{replType:0}})
    } else {
        setSelectedFilters(prev => [...prev, type]);
        if (updateControlPrefs) updateControlPrefs({'expansions':{replType:1}})
    }
  };

  const Row: React.FC<{ item: any }> = React.memo(({ item }) => {
    // const Row: React.FC<{item: any}> = ({ item }) => {
      if (!item) return <></>;
      return (
          <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={0.5}
          >
            <Stack
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={0.5}
            >             
              <ColoredChip 
                  variant="geekblue" 
                  label={item.event || "noevent"} 
                  tooltip={new Date(item.timestamp || 0).toLocaleString()}
                  size="small"
              />
              
              <Typography variant="caption">
                <ElapsedTime timestamp = {item.timestamp || 0} sourceUnits = "ms" />
              </Typography>

              </Stack> 
              <JsonViewer
                rootName={false}
                value={item.data}
                theme="light"
                indentWidth={2}
                enableClipboard={true}
                editable={false}
                defaultInspectDepth={1}
                displayDataTypes={false}
                style={{ fontSize: '12px' }}
                quotesOnKeys={false}
              />
          </Stack>
      );
  });
           

  useEffect(() => {
    const filterExpansions = () => {
      if (controlPrefs?.expansions) {
        const filteredKeys = Object.keys(controlPrefs?.expansions).filter(key => {
          const value = controlPrefs?.expansions[key];
          return typeof value !== 'object' && value; 
        });
  
        return filteredKeys.map(key => key.replace('~', '.'));
      } else {
        return [];
      }
    };
    setSelectedFilters(filterExpansions);  
  }, [controlPrefs?.expansions]); 
  
  const filteredEvents = useMemo(() => {
    return shuteMessageHx.filter(item => 
        item && selectedFilters.includes(item.event)
    );
  }, [shuteMessageHx, selectedFilters]);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    // const newPageState = tabsConfig.reduce((acc, tab, index) => {
    //   acc[tab.label] = index === newValue;
    //   return acc;
    // }, {} as TabsState);

    // if (setExpansions) setExpansions(newPageState);
    setTabSelected(newValue);
  };
return (
  <div ref={contentRef}
    style={{ 
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    width: "50vw",
    maxHeight: '80vh', 
    overflowY: 'auto',  
    backgroundColor: 'white',
    padding: '16px 32px',
    borderRadius: '8px',
    boxShadow: '0 3px 7px rgba(0, 0, 0, 0.3)'

  }}>
    <Tabs value={tabSelected} onChange={handleChange}>
      <Tab label="Event List" />
      <Tab label="Connections" />
    </Tabs>

    {/* Tab 0 Content (Event List) */}
    {tabSelected === 0 && (
      <div>

      {/* <h2 id="simple-modal-title">Event List</h2> */}
        {uniqueEventTypes.length>0 && 
          <div
              onMouseEnter={() => setExpandFilters(true)}
              onMouseLeave={() => setExpandFilters(false)}
              style={{ overflowX: 'auto', maxHeight: expandFilters ? 'auto' : '32px' }}
          >
              {uniqueEventTypes.map(type => (
                  type && <Chip 
                      key={type}
                      label={type}
                      clickable
                      onClick={() => toggleFilter(type)}
                      color={selectedFilters.includes(type) ? 'primary' : 'default'}
                  />
              ))}
          </div>
        }
        {filteredEvents.map((item, index) => (
          <Row item={item} key={item?.key} />
        ))}
        {/* The bottom element to help with the smooth scroll */}
      <div ref={bottomEl}></div>

      </div>
    )}

    {tabSelected === 1 && (
      <div>
        <ShutePanel 
          currentEventListeners={currentEventListeners}
          pendingEventListeners={pendingEventListeners}
          queuedEventListeners={queuedEventListeners}
          listeners={listeners}
          callbackRegistry={callbackRegistry}
        />
      </div> 
    )}
  </div>
  )
};




interface ShutePanelProps {
  currentEventListeners: string[];
  pendingEventListeners: string[];
  queuedEventListeners: QueuedEventListener[];
  listeners: Record<string, Record<string, string[]>>;
  callbackRegistry: Record<string, CallbackRegistryItem>;
}
interface ListenersContext {
  [event: string]: {
    contexts?: {
      [page: string]: string[];
    },
    callbackKeys?: string[];
  }
}
const ShutePanel: React.FC<ShutePanelProps> = ({
  currentEventListeners,
  pendingEventListeners,
  queuedEventListeners,
  listeners,
  callbackRegistry
}) => {

  const [expandedItems, setExpandedItems] = useState<string[]>([]);
  const [preprocessedListeners, setPreprocessedListeners] = useState<ListenersContext>({});
  useEffect(()=>{
    let newListeners:ListenersContext = {};
    for (const page in listeners) {
      for (const event in listeners[page]) {
        const contexts = listeners[page][event];
        // Add or Update Event within the new object
        if (!newListeners[event]) {
          newListeners[event] = {contexts:{}};
        }
        else if (!newListeners[event].contexts) {
          newListeners[event].contexts = {};
        }

        // Add or Extend Contexts for the Page
        if (!newListeners[event]?.contexts?.[page]) {
          newListeners[event].contexts![page] = contexts;
        } else {
          newListeners[event].contexts![page] = newListeners[event].contexts![page].concat(contexts);
        }
      }
   }
   for (const event in callbackRegistry) {
    if (!newListeners[event]) {
      newListeners[event] = {callbackKeys:[]};
    }
    newListeners[event].callbackKeys = callbackRegistry[event].callbackKeys;
   }
   setPreprocessedListeners(newListeners)
  },[listeners,callbackRegistry])


  const handleExpandClick = (listener:string) => {
    setExpandedItems((prev) =>
      prev.includes(listener)
        ? prev.filter((item) => item !== listener)
        : [...prev, listener]
    );
  };


  return (
    
    <Grid container spacing={2}>{/* Outer grid for layout */}
      {/* Current Event Listeners */}
      <Grid xs={12}>
        <Typography variant="h6">Current Event Listeners</Typography>
        <List>
          {currentEventListeners.map((listener) => (
            <div 
              key={`${listener}.celistenrs`}>
              <ListItem disablePadding>
                <ListItemButton onClick={() => handleExpandClick(listener)}>
                  {preprocessedListeners[listener] ? 
                    expandedItems.includes(listener) ? (
                      <OrbotnikIcon icon={<ExpandLess />} />
                    ) : (
                      <OrbotnikIcon icon={<ExpandMore />} />
                    ) : <></>
                  }
                  <ListItemText primary={listener} />
                </ListItemButton>
              </ListItem>
              <Collapse in={expandedItems.includes(listener)}>
                <FlexContainer  
                  style={{ marginLeft:4 }}>
                  <FlexChild 
                    sx={{ maxWidth: '100%' }}
                    alignSelf="stretch"
                  >
                    <Typography variant='overline'>Callbacks</Typography>
                  </FlexChild>
                  <FlexChild
                    sx={{ maxWidth: '100%' }}
                    alignSelf="stretch"
                  >
                    <Stack
                      direction="column"
                      justifyContent="center"
                      alignItems="flex-start"
                      spacing={0.5}
                    >
                      {preprocessedListeners[listener]?.callbackKeys?.map((key) => (
                        <ColoredTag
                          variant='geekblue'
                          key={`${key}.cbreg`}
                          children={
                            <Typography variant="body2" style={{ 
                                color: '#6d6d6d', 
                                  }}>
                              {key}
                          </Typography>}
                        />    
                      ))}
                    </Stack>
                  </FlexChild>
                </FlexContainer>

                {preprocessedListeners[listener]?.contexts && 
                  <Stack 
                    direction="row" 
                    spacing={2} 
                    sx={{ pl:4,  alignItems: 'stretch' }}
                  >
                    <Typography variant='overline'>Contexts</Typography>

                    {Object.entries(preprocessedListeners[listener].contexts!).map(([page, contexts]) => (                            
                      <Stack 
                        key={`contexts.${listener}.${page}`}
                        direction="row" 
                        spacing={2} 
                        sx={{ alignItems: 'stretch' }}>
                        <ColoredTag
                          variant='volcano'
                          children={<Typography variant="body2" style={{ 
                                color: '#6d6d6d', 
                                    }}>
                                {page}
                                </Typography>}
                        />
                        <div style={{ flexGrow: 1 }}>  
                            {contexts.map((context) => (
                              <ColoredTag
                                key={`${listener}.${page}.${context}.pagecontext`}
                                variant='red'
                                children={
                                  <Typography variant="body2" style={{ 
                                      color: '#6d6d6d', 
                                        }}>
                                    {context || "[none]"}
                                  </Typography>
                                }
                              />       
                              ))}
                        </div>
                        </Stack>
                      ))
                    }
                  </Stack>                
                }
              </Collapse>
              <Divider />
            </div>
          ))}
        </List>
      </Grid>

      {pendingEventListeners && pendingEventListeners.length > 0 &&
      <Grid xs={12}>
        <Typography variant="h6">Pending Event Listeners</Typography>
        <ul>
          {pendingEventListeners.map((listener) => (
            <li key={`pendingEventListeners.${listener}`}>{listener}</li>
          ))}
        </ul>
      </Grid>}

      {/* Queued Event Listeners */}
      {queuedEventListeners && queuedEventListeners.length > 0 &&
      <Grid xs={12}>
        <Typography variant="h6">Queued Event Listeners</Typography>
        <ul>
          {queuedEventListeners.map((listener) => (
            <li key={`queued.${listener.sessionid}`}> 
              {listener.page} - {listener.watchevents.join(', ')} 
            </li>
          ))}
        </ul>
      </Grid>}
    </Grid>
  );
};

